export default __webpack_public_path__ + "static/media/logo5.33422dd2.jpeg";